import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/nfts/auction1.gif'
import _imports_1 from '@/assets/images/users/user58.jpg'
import _imports_2 from '@/assets/images/nfts/auction2.gif'
import _imports_3 from '@/assets/images/users/user59.jpg'
import _imports_4 from '@/assets/images/nfts/auction3.jpg'
import _imports_5 from '@/assets/images/users/user60.jpg'
import _imports_6 from '@/assets/images/nfts/auction4.jpg'
import _imports_7 from '@/assets/images/users/user61.jpg'
import _imports_8 from '@/assets/images/nfts/auction5.jpg'
import _imports_9 from '@/assets/images/users/user62.jpg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-dropdown relative" }
const _hoisted_5 = { class: "trezo-card-content" }
const _hoisted_6 = { class: "table-responsive overflow-x-auto" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "text-black dark:text-white" }
const _hoisted_9 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }
const _hoisted_10 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }
const _hoisted_11 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }
const _hoisted_12 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }
const _hoisted_13 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Active Auctions")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block rounded-md border border-gray-100 bg-gray-100 dark:bg-[#0a0e19] py-[5px] md:py-[6.5px] px-[12px] md:px-[19px] transition-all hover:bg-gray-50 dark:border-[#172036] dark:hover:bg-[#0a0e19]': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }, [
              _createTextVNode(" Monthly "),
              _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2 mt-px" })
            ], -1)
          ]), 2),
          _cache[2] || (_cache[2] = _createElementVNode("ul", { class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none" }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, " Weekly ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, " Monthly ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, " Yearly ")
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[34] || (_cache[34] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "whitespace-nowrap uppercase text-[10px] font-bold tracking-[1px] ltr:text-left rtl:text-right pt-0 pb-[10px] px-[20px] text-gray-400 ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:first:pl-0 ltr:last:text-right rtl:last:text-left" }, " Item "),
              _createElementVNode("th", { class: "whitespace-nowrap uppercase text-[10px] font-bold tracking-[1px] ltr:text-left rtl:text-right pt-0 pb-[10px] px-[20px] text-gray-400 ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:first:pl-0 ltr:last:text-right rtl:last:text-left" }, " Open Price "),
              _createElementVNode("th", { class: "whitespace-nowrap uppercase text-[10px] font-bold tracking-[1px] ltr:text-left rtl:text-right pt-0 pb-[10px] px-[20px] text-gray-400 ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:first:pl-0 ltr:last:text-right rtl:last:text-left" }, " Your Offer "),
              _createElementVNode("th", { class: "whitespace-nowrap uppercase text-[10px] font-bold tracking-[1px] ltr:text-left rtl:text-right pt-0 pb-[10px] px-[20px] text-gray-400 ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:first:pl-0 ltr:last:text-right rtl:last:text-left" }, " Recent Offer "),
              _createElementVNode("th", { class: "whitespace-nowrap uppercase text-[10px] font-bold tracking-[1px] ltr:text-left rtl:text-right pt-0 pb-[10px] px-[20px] text-gray-400 ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:first:pl-0 ltr:last:text-right rtl:last:text-left" }, " Time Left "),
              _createElementVNode("th", { class: "whitespace-nowrap uppercase text-[10px] font-bold tracking-[1px] ltr:text-left rtl:text-right pt-0 pb-[10px] px-[20px] text-gray-400 ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:first:pl-0 ltr:last:text-right rtl:last:text-left" }, " View ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_8, [
            _createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[50px]" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "inline-block rounded-[6px]",
                      alt: "auction-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-semibold inline-block mb-px" }, " Christmas Eve "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " by John Lira ")
                  ])
                ])
              ], -1)),
              _cache[6] || (_cache[6] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 11.75 ETH ")
              ], -1)),
              _cache[7] || (_cache[7] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 10.00 ETH ")
              ], -1)),
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[5px]" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "w-[22px] rounded-full",
                    alt: "user-image"
                  }),
                  _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 10.00 ETH ")
                ])
              ], -1)),
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", {
                  class: "active-auctions-timer block text-xs font-semibold text-gray-600 dark:text-gray-400",
                  "data-duration": "9900",
                  id: "active-auctions-timer"
                }, [
                  _createElementVNode("span", { class: "hours-span" }, [
                    _createElementVNode("span", { class: "hours" }, "00"),
                    _createTextVNode("h ")
                  ]),
                  _createElementVNode("span", { class: "minutes-span" }, [
                    _createElementVNode("span", { class: "minutes" }, "00"),
                    _createTextVNode("m ")
                  ]),
                  _createElementVNode("span", { class: "seconds-span" }, [
                    _createElementVNode("span", { class: "seconds" }, "00"),
                    _createTextVNode("s ")
                  ])
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "inline-block rounded-full w-[30px] h-[30px] bg-gray-100 dark:bg-[#172036] text-center leading-[30px] text-[18px] text-gray-400 transition-all hover:bg-primary-500 hover:text-white"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[50px]" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "inline-block rounded-[6px]",
                      alt: "auction-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-semibold inline-block mb-px" }, " Rotating Flower "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " by WalterW. ")
                  ])
                ])
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 9.25 ETH ")
              ], -1)),
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 6.10 ETH ")
              ], -1)),
              _cache[14] || (_cache[14] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[5px]" }, [
                  _createElementVNode("img", {
                    src: _imports_3,
                    class: "w-[22px] rounded-full",
                    alt: "user-image"
                  }),
                  _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 7.15 ETH ")
                ])
              ], -1)),
              _cache[15] || (_cache[15] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", {
                  class: "active-auctions-timer block text-xs font-semibold text-gray-600 dark:text-gray-400",
                  "data-duration": "4860",
                  id: "active-auctions-timer"
                }, [
                  _createElementVNode("span", { class: "hours-span" }, [
                    _createElementVNode("span", { class: "hours" }, "00"),
                    _createTextVNode("h ")
                  ]),
                  _createElementVNode("span", { class: "minutes-span" }, [
                    _createElementVNode("span", { class: "minutes" }, "00"),
                    _createTextVNode("m ")
                  ]),
                  _createElementVNode("span", { class: "seconds-span" }, [
                    _createElementVNode("span", { class: "seconds" }, "00"),
                    _createTextVNode("s ")
                  ])
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_10, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "inline-block rounded-full w-[30px] h-[30px] bg-gray-100 dark:bg-[#172036] text-center leading-[30px] text-[18px] text-gray-400 transition-all hover:bg-primary-500 hover:text-white"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[17] || (_cache[17] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[50px]" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "inline-block rounded-[6px]",
                      alt: "auction-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-semibold inline-block mb-px" }, " Windows Art "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " by Christino ")
                  ])
                ])
              ], -1)),
              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 17.24 ETH ")
              ], -1)),
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 11.75 ETH ")
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[5px]" }, [
                  _createElementVNode("img", {
                    src: _imports_5,
                    class: "w-[22px] rounded-full",
                    alt: "user-image"
                  }),
                  _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 14.11 ETH ")
                ])
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", {
                  class: "active-auctions-timer block text-xs font-semibold text-gray-600 dark:text-gray-400",
                  "data-duration": "2580",
                  id: "active-auctions-timer"
                }, [
                  _createElementVNode("span", { class: "hours-span" }, [
                    _createElementVNode("span", { class: "hours" }, "00"),
                    _createTextVNode("h ")
                  ]),
                  _createElementVNode("span", { class: "minutes-span" }, [
                    _createElementVNode("span", { class: "minutes" }, "00"),
                    _createTextVNode("m ")
                  ]),
                  _createElementVNode("span", { class: "seconds-span" }, [
                    _createElementVNode("span", { class: "seconds" }, "00"),
                    _createTextVNode("s ")
                  ])
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_11, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "inline-block rounded-full w-[30px] h-[30px] bg-gray-100 dark:bg-[#172036] text-center leading-[30px] text-[18px] text-gray-400 transition-all hover:bg-primary-500 hover:text-white"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[23] || (_cache[23] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[50px]" }, [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "inline-block rounded-[6px]",
                      alt: "auction-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-semibold inline-block mb-px" }, " 3D Logo "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " by Hater ")
                  ])
                ])
              ], -1)),
              _cache[24] || (_cache[24] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 12.12 ETH ")
              ], -1)),
              _cache[25] || (_cache[25] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 10.24 ETH ")
              ], -1)),
              _cache[26] || (_cache[26] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[5px]" }, [
                  _createElementVNode("img", {
                    src: _imports_7,
                    class: "w-[22px] rounded-full",
                    alt: "user-image"
                  }),
                  _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 12.08 ETH ")
                ])
              ], -1)),
              _cache[27] || (_cache[27] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", {
                  class: "active-auctions-timer block text-xs font-semibold text-gray-600 dark:text-gray-400",
                  "data-duration": "6600",
                  id: "active-auctions-timer"
                }, [
                  _createElementVNode("span", { class: "hours-span" }, [
                    _createElementVNode("span", { class: "hours" }, "00"),
                    _createTextVNode("h ")
                  ]),
                  _createElementVNode("span", { class: "minutes-span" }, [
                    _createElementVNode("span", { class: "minutes" }, "00"),
                    _createTextVNode("m ")
                  ]),
                  _createElementVNode("span", { class: "seconds-span" }, [
                    _createElementVNode("span", { class: "seconds" }, "00"),
                    _createTextVNode("s ")
                  ])
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_12, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "inline-block rounded-full w-[30px] h-[30px] bg-gray-100 dark:bg-[#172036] text-center leading-[30px] text-[18px] text-gray-400 transition-all hover:bg-primary-500 hover:text-white"
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[29] || (_cache[29] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[10px]" }, [
                  _createElementVNode("div", { class: "rounded-full w-[50px]" }, [
                    _createElementVNode("img", {
                      src: _imports_8,
                      class: "inline-block rounded-[6px]",
                      alt: "auction-image"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "font-semibold inline-block mb-px" }, " Awesome Bird "),
                    _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 text-xs" }, " by Liveslong ")
                  ])
                ])
              ], -1)),
              _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 8.15 ETH ")
              ], -1)),
              _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 7.15 ETH ")
              ], -1)),
              _cache[32] || (_cache[32] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("div", { class: "flex items-center gap-[5px]" }, [
                  _createElementVNode("img", {
                    src: _imports_9,
                    class: "w-[22px] rounded-full",
                    alt: "user-image"
                  }),
                  _createElementVNode("span", { class: "block text-xs font-semibold text-gray-600 dark:text-gray-400" }, " 8.08 ETH ")
                ])
              ], -1)),
              _cache[33] || (_cache[33] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[10px] ltr:first:pl-0 rtl:first:pr-0 border-b border-primary-50 dark:border-[#172036] ltr:last:pr-0 rtl:last:pl-0 ltr:last:text-right rtl:last:text-left" }, [
                _createElementVNode("span", {
                  class: "active-auctions-timer block text-xs font-semibold text-gray-600 dark:text-gray-400",
                  "data-duration": "15300",
                  id: "active-auctions-timer"
                }, [
                  _createElementVNode("span", { class: "hours-span" }, [
                    _createElementVNode("span", { class: "hours" }, "00"),
                    _createTextVNode("h ")
                  ]),
                  _createElementVNode("span", { class: "minutes-span" }, [
                    _createElementVNode("span", { class: "minutes" }, "00"),
                    _createTextVNode("m ")
                  ]),
                  _createElementVNode("span", { class: "seconds-span" }, [
                    _createElementVNode("span", { class: "seconds" }, "00"),
                    _createTextVNode("s ")
                  ])
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_13, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "inline-block rounded-full w-[30px] h-[30px] bg-gray-100 dark:bg-[#172036] text-center leading-[30px] text-[18px] text-gray-400 transition-all hover:bg-primary-500 hover:text-white"
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        items: "5",
        total: "30"
      })
    ])
  ]))
}